export type Language = "ja" | "en";

const ensureLeadingSlash = (pathname: string): string =>
	pathname.startsWith("/") ? pathname : `/${pathname}`;

export const getLanguageFromPath = (pathname = "/"): Language =>
	/^\/ja(?:\/|$)/.test(pathname) ? "ja" : "en";

export const getUnlocalizedPath = (pathname = "/"): string => {
	const pathOnly = ensureLeadingSlash(pathname.split(/[?#]/)[0] || "/");
	const unlocalized = pathOnly.replace(/^\/ja(?=\/|$)/, "");
	return unlocalized || "/";
};

export const getLocalizedPath = (
	pathname: string,
	language: Language
): string => {
	let pagePath = getUnlocalizedPath(pathname);

	// WordPress posts do not currently store a relationship between translations.
	// Switch news detail pages to the destination language's news index instead.
	if (/^\/news\/[^/]+\/?$/.test(pagePath)) {
		pagePath = "/news/";
	}

	if (language === "ja") {
		return pagePath === "/" ? "/ja/" : `/ja${pagePath}`;
	}

	return pagePath;
};

export const withTrailingSlash = (pathname: string): string => {
	const pathOnly = ensureLeadingSlash(pathname.split(/[?#]/)[0] || "/");
	return pathOnly === "/" || pathOnly.endsWith("/")
		? pathOnly
		: `${pathOnly}/`;
};
